import React from "react"
import { ButtonBase } from "@mui/material"
import { FaIcon } from "../../../../../mp-core/icons"
import { StylesType } from "../styles"

interface Props {
  isCardOpen: boolean
  type: string
  classes: StylesType
  onOpenClose: () => void
}

const CARD_ICONS = {
  whats_new: "gift",
  ready: "lightbulb",
  tip: "lightbulb",
  general: "bullhorn",
  custom: "comment-alt"
}

const GhostieHeader: React.FC<Props> = ({
  isCardOpen,
  type,
  classes,
  onOpenClose
}) => {
  return (
    <ButtonBase
      className={classes.openCloseButton}
      onClick={onOpenClose}
      aria-label={`${!isCardOpen ? "Open" : "Close"} Announcement`}
    >
      {isCardOpen ? (
        <FaIcon solid name="times" />
      ) : (
        <FaIcon solid name={CARD_ICONS[type] ?? "graduation-cap"} />
      )}
    </ButtonBase>
  )
}

export default GhostieHeader
